function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import parseUrl from 'url-parse';
import Modal from '../components/modal';
import { hideLoadingOverlay, showLoadingOverlay } from '../../loadingOverlay';
import { useStorefrontApi } from '../../common/hooks/useStorefrontApi';
import { trackAddToCartEvent, trackBeginCheckoutEvent } from '../../trackers/utils';
import { BTCheckoutCartAdapter } from '../../trackers/adapater/cart/btCheckoutCartAdapter';
import { CheckoutProvider } from '../../enum';
import { StorefrontCartAdapter } from '../../trackers/adapater/cart/storefrontCartAdapter';
import { appendTuneAttributes } from '../../trackers/hasoffers';

var _ref = window.bt || {},
    _ref$lil = _ref.lil;

_ref$lil = _ref$lil === void 0 ? {} : _ref$lil;
var pageHandle = _ref$lil.pageHandle,
    _ref$lil$storefrontAp = _ref$lil.storefrontApiToken;
_ref$lil$storefrontAp = _ref$lil$storefrontAp === void 0 ? {} : _ref$lil$storefrontAp;
var salesLandersApiToken = _ref$lil$storefrontAp.salesLanders,
    _ref$lil$enabledCheck = _ref$lil.enabledCheckout,
    enabledCheckout = _ref$lil$enabledCheck === void 0 ? CheckoutProvider.BT_CHECKOUT : _ref$lil$enabledCheck,
    landerToken = _ref$lil.landerToken,
    _ref$settings = _ref.settings;
_ref$settings = _ref$settings === void 0 ? {} : _ref$settings;
var _ref$settings$btCheck = _ref$settings.btCheckout;
_ref$settings$btCheck = _ref$settings$btCheck === void 0 ? {} : _ref$settings$btCheck;
var _ref$settings$btCheck2 = _ref$settings$btCheck.url,
    btCheckoutBaseUrl = _ref$settings$btCheck2 === void 0 ? 'https://secure.biotrust.com' : _ref$settings$btCheck2,
    vanityDomain = _ref$settings.vanityDomain;

var _ref2 = window.Shopify || {},
    _ref2$Checkout = _ref2.Checkout;

_ref2$Checkout = _ref2$Checkout === void 0 ? {} : _ref2$Checkout;
var _ref2$Checkout$apiHos = _ref2$Checkout.apiHost,
    shopifyDomain = _ref2$Checkout$apiHos === void 0 ? window.location.host : _ref2$Checkout$apiHos;
export default function LILOneThreeSixFlavorSelector(_ref3) {
  var flavorCYPs = _ref3.flavorCYPs;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedQuantity = _useState4[0],
      setSelectedQuantity = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isAddingToCart = _useState6[0],
      setIsAddingToCart = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      sellingPlanId = _useState8[0],
      setSellingPlanId = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      currentProduct = _useState10[0],
      setCurrentProduct = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      freeReports = _useState12[0],
      setFreeReports = _useState12[1];

  var _useState13 = useState(true),
      _useState14 = _slicedToArray(_useState13, 2),
      freePlusShipping = _useState14[0],
      setFreePlusShipping = _useState14[1];

  useEffect(function () {
    flavorCYPs.forEach(function (cyp) {
      $(cyp.selector).css('cursor', 'pointer').on('click', getModalButtonClickHandler(cyp.quantity, cyp.product, cyp.freeReports, cyp.sellingPlan, cyp.freePlusShipping));
    });
  }, []);

  var _useStorefrontApi = useStorefrontApi(salesLandersApiToken, shopifyDomain),
      createCart = _useStorefrontApi.createCart;

  function getModalButtonClickHandler(quantity, product, freeReportsToAdd) {
    var sellingPlan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var fps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    return function (evt) {
      evt.preventDefault();
      setSelectedQuantity(quantity);
      setCurrentProduct(product);
      setFreeReports(freeReportsToAdd);
      setSellingPlanId(sellingPlan === null || sellingPlan === void 0 ? void 0 : sellingPlan.id);
      setFreePlusShipping(fps);
      setIsModalOpen(true);
      return true;
    };
  }

  function handleAddToCart() {
    return _handleAddToCart.apply(this, arguments);
  }

  function _handleAddToCart() {
    _handleAddToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var variantQuantities,
          _window$btDataLayer,
          _window$bt,
          _window$bt$settings,
          _window$btDataLayer2,
          sessionId,
          agentId,
          attributes,
          createCartPayload,
          checkout,
          cartAdapter,
          _checkoutUrl,
          parsedUrl,
          checkoutUrl,
          cart,
          res,
          cartResponse,
          responseContent,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              variantQuantities = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
              setIsAddingToCart(true);
              setIsModalOpen(false);
              showLoadingOverlay();

              if (!(enabledCheckout === CheckoutProvider.SHOPIFY_CHECKOUT || variantQuantities.some(function (vq) {
                return vq.sellingPlanId;
              }))) {
                _context.next = 30;
                break;
              }

              _context.prev = 5;
              sessionId = (((_window$btDataLayer = window.btDataLayer) === null || _window$btDataLayer === void 0 ? void 0 : _window$btDataLayer.sessionId) || Cookies.get((_window$bt = window.bt) === null || _window$bt === void 0 ? void 0 : (_window$bt$settings = _window$bt.settings) === null || _window$bt$settings === void 0 ? void 0 : _window$bt$settings.sessionCookieName) || '').trim();
              agentId = (((_window$btDataLayer2 = window.btDataLayer) === null || _window$btDataLayer2 === void 0 ? void 0 : _window$btDataLayer2.agentId) || Cookies.get('bt') || '').trim();
              attributes = [{
                key: 'bt_lander',
                value: pageHandle
              }];

              if (landerToken) {
                attributes.push({
                  key: 'bt_lander_token',
                  value: "".concat(landerToken)
                });
              }

              appendTuneAttributes(attributes);
              createCartPayload = {
                attributes: attributes,
                lines: [].concat(_toConsumableArray(variantQuantities), _toConsumableArray(freeReports)).map(function (vq) {
                  var cartLine = {
                    quantity: vq.quantity,
                    merchandiseId: vq.merchandiseId || "gid://shopify/ProductVariant/".concat(vq.variant.id),
                    attributes: [{
                      key: '_bt_lander',
                      value: "".concat(pageHandle)
                    }, {
                      key: '_bt_lander_shipping',
                      value: freePlusShipping ? 'flat-rate' : 'free'
                    }, {
                      key: '_cpSessionId',
                      value: sessionId || 'trackers-not-yet-initialized'
                    }, {
                      key: '_cpAgentId',
                      value: agentId || 'trackers-not-yet-initialized'
                    }]
                  };

                  if (vq.sellingPlanId) {
                    cartLine.sellingPlanId = "gid://shopify/SellingPlan/".concat(vq.sellingPlanId);
                  }

                  return cartLine;
                }).reverse()
              };
              _context.next = 14;
              return createCart(createCartPayload);

            case 14:
              checkout = _context.sent;
              cartAdapter = new StorefrontCartAdapter(createCartPayload.lines, checkout.cart);
              trackAddToCartEvent(cartAdapter);
              trackBeginCheckoutEvent(cartAdapter);
              _checkoutUrl = checkout.checkoutUrl;
              console.debug('[ShopifyCheckout] Shopify checkout created', {
                id: checkout.id,
                checkoutUrl: _checkoutUrl,
                cart: JSON.stringify(checkout)
              });
              parsedUrl = parseUrl(_checkoutUrl, true);

              if (parsedUrl.host === shopifyDomain && vanityDomain) {
                parsedUrl.host = vanityDomain;
              }

              window.location.assign(parsedUrl.toString(null));
              _context.next = 29;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](5);
              window.alert(_context.t0 && _context.t0.message || 'Something went wrong');
              hideLoadingOverlay();

            case 29:
              return _context.abrupt("return");

            case 30:
              checkoutUrl = new URL("/checkout/".concat(pageHandle), btCheckoutBaseUrl);
              cart = variantQuantities.reduce(function (acc, vq) {
                return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, vq.variant.sku, vq.quantity));
              }, {});
              _context.prev = 32;
              _context.next = 35;
              return window.fetch("".concat(btCheckoutBaseUrl, "/api/cart"), {
                method: 'POST',
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify({
                  funnel: pageHandle,
                  items: cart
                })
              });

            case 35:
              res = _context.sent;

              if (!res.ok) {
                _context.next = 45;
                break;
              }

              _context.next = 39;
              return res.json();

            case 39:
              cartResponse = _context.sent;
              trackAddToCartEvent(new BTCheckoutCartAdapter(cart, cartResponse));
              window.location.assign(checkoutUrl);
              return _context.abrupt("return");

            case 45:
              _context.next = 47;
              return res.text();

            case 47:
              responseContent = _context.sent;
              console.error('Unsuccessful response when adding to cart for BT Checkout', {
                status: res.status,
                body: responseContent
              });
              window.alert('Something went wrong');
              hideLoadingOverlay();

            case 51:
              _context.next = 58;
              break;

            case 53:
              _context.prev = 53;
              _context.t1 = _context["catch"](32);
              console.error('Error adding to BT Checkout cart!', _context.t1);
              window.alert(_context.t1 && _context.t1.message || 'Something went wrong');
              hideLoadingOverlay();

            case 58:
              setIsAddingToCart(false);

            case 59:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 25], [32, 53]]);
    }));
    return _handleAddToCart.apply(this, arguments);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  return currentProduct &&
  /*#__PURE__*/

  /* eslint-disable quotes */

  /* ¯\_(ツ)_/¯ */
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: isModalOpen,
    isBusy: isAddingToCart,
    sellingPlanId: sellingPlanId,
    quantity: selectedQuantity,
    onRequestClose: handleCloseModal,
    product: currentProduct,
    onAddToCart: handleAddToCart
  }));
}
LILOneThreeSixFlavorSelector.propTypes = {
  flavorCYPs: PropTypes.arrayOf(PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    selector: PropTypes.string.isRequired,
    product: PropTypes.object,
    isSNS: PropTypes.bool,
    freeReports: PropTypes.arrayOf(PropTypes.shape({
      quantity: PropTypes.number.isRequired,
      merchandiseId: PropTypes.string.isRequired
    })),
    freePlusShipping: PropTypes.bool
  })).isRequired
};